<script>
export default {
    name: "PendingInpatientInvestigations",

    props: {
        showModal: Boolean,
        pendingInvestigations: Array,
    },

    methods: {

        printRoundReport() {
            window.open(`/radiology/patients-round-report-print`, 
                '_blank', 
                `RadiologyRoundPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Pending Inpatient Requests</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <table class="table">
                <thead class="bg-blue-500 text-white text-sm">
                    <tr class="flex w-full">
                        <th class="p-tiny w-1/6">Patient</th>
                        <th class="p-tiny flex-1">Date</th>
                        <th class="p-tiny flex-1">Progress</th>
                        <th class="p-tiny flex-1">IP No</th>
                        <th class="p-tiny flex-1">OP No</th>
                        <th class="p-tiny w-1/6">Payment</th>
                        <th class="p-tiny flex-1">Bed</th>
                        <th class="p-tiny flex-1">Ward</th>
                        <th class="p-tiny w-1/6">Test</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-200 text-xs font-medium flex flex-col items-center 
                    overflow-auto w-full" style="max-height:50vh;">
                    <tr class="flex w-full" 
                        v-for="(pat, idx) in pendingInvestigations" :key="idx">
                        <td class="p-tiny w-1/6">
                            <h5 class="text-sm text-gray-900">{{ pat.names }}</h5>
                            <h5 class="text-xs leading-5 text-gray-700">MRN: {{ pat.patienT_ID }}</h5>
                            <h5 class="text-xs leading-5 text-gray-700">DOB: {{ pat.dob | dateFormat }}</h5>
                        </td>
                        <td class="p-tiny flex-1">{{ pat.date | dateFormat }}</td>
                        <td class="p-tiny flex-1">{{ pat.progress }}</td>
                        <td class="p-tiny flex-1">{{ pat.ipfileno }}</td>
                        <td class="p-tiny flex-1">{{ pat.opfileno }}</td>
                        <td class="p-tiny w-1/6">{{ pat.pmode }}</td>
                        <td class="p-tiny flex-1">{{ pat.ward || `-` }}</td>
                        <td class="p-tiny flex-1">{{ pat.bed || `-` }}</td>
                        <td class="p-tiny w-1/6">{{ pat.itemName }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button @click.prevent="printRoundReport"
            class="btn-primary btn-sm text-xs rounded">
                <i class="fa fa-print"></i> Print</button>
      </template>
    </tail-modal>
</template>